import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function LoginPage() {
  const navigate = useNavigate();
  const handleCohortSelect = (cohort: number) => {
    navigate('/loading');
  };
  return <div className="min-h-screen bg-catalyst-black flex flex-col relative overflow-hidden font-body" data-id="element-570">
      {/* Background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-571">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-catalyst-mustard/8 blur-[150px]" data-id="element-572"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[40%] h-[40%] rounded-full bg-catalyst-brown-dark/20 blur-[120px]" data-id="element-573"></div>
        <div className="absolute top-[40%] right-[20%] w-[30%] h-[30%] rounded-full bg-catalyst-mustard/5 blur-[100px]" data-id="element-574"></div>
      </div>

      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-575"></div>

      {/* Top accent bar */}
      <div className="w-full h-1 bg-gradient-to-r from-transparent via-catalyst-mustard to-transparent" data-id="element-576"></div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col justify-center items-center z-10 px-6 py-16" data-id="element-577">
        <div className="w-full max-w-2xl text-center" data-id="element-578">
          {/* Logo */}
          <div className="mb-16" data-id="element-579">
            <img src="https://cdn.magicpatterns.com/uploads/fhU3kGRUAmhJPAYevpphn9/header-logo.png" alt="Black Opportunity Fund" className="h-20 mx-auto filter brightness-0 invert" data-id="element-580" />
          </div>

          {/* Title Block */}
          <div className="mb-20 space-y-6" data-id="element-581">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-[1.1] tracking-tight" data-id="element-582">
              BOF <span className="text-catalyst-mustard" data-id="element-583">Catalyst</span>
            </h1>
            <div className="w-24 h-1 bg-catalyst-mustard mx-auto rounded-full" data-id="element-584"></div>
            <p className="text-xl md:text-2xl text-gray-300 font-light max-w-xl mx-auto leading-relaxed" data-id="element-585">
              Learning Management Platform
            </p>
            <p className="text-catalyst-mustard font-semibold tracking-[0.25em] text-sm uppercase" data-id="element-586">
              Scale with intention. Build with access.
            </p>
          </div>

          {/* Program Description */}
          <div className="mb-20 max-w-xl mx-auto" data-id="element-587">
            <p className="text-base text-gray-400 leading-relaxed" data-id="element-588">
              A six-month business program for high-growth entrepreneurs
              supported by the{' '}
              <span className="text-catalyst-mustard font-medium" data-id="element-589">
                Federal Economic Development Agency for Southern Ontario
              </span>
              , a department within the Canadian government.
            </p>
          </div>

          {/* Cohort Selection */}
          <div className="space-y-6 mb-20" data-id="element-590">
            <p className="text-gray-500 text-sm font-medium uppercase tracking-widest" data-id="element-591">
              Select your cohort to continue
            </p>

            <div className="flex flex-col sm:flex-row gap-5 justify-center max-w-lg mx-auto" data-id="element-592">
              <button onClick={() => handleCohortSelect(1)} className="group flex-1 bg-catalyst-mustard text-catalyst-black py-5 px-10 rounded-xl text-lg font-bold hover:bg-catalyst-mustard-light transition-all duration-200 shadow-lg shadow-catalyst-mustard/25 hover:shadow-xl hover:shadow-catalyst-mustard/35 flex items-center justify-center gap-3" data-id="element-593">
                Enter Cohort 1
                <ArrowRight size={22} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-594" />
              </button>

              <button onClick={() => handleCohortSelect(2)} className="group flex-1 bg-catalyst-mustard text-catalyst-black py-5 px-10 rounded-xl text-lg font-bold hover:bg-catalyst-mustard-light transition-all duration-200 shadow-lg shadow-catalyst-mustard/25 hover:shadow-xl hover:shadow-catalyst-mustard/35 flex items-center justify-center gap-3" data-id="element-595">
                Enter Cohort 2
                <ArrowRight size={22} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-596" />
              </button>
            </div>
          </div>

          {/* Request Access */}
          <div className="mb-16" data-id="element-597">
            <a href="#" className="inline-flex items-center gap-2 text-sm text-catalyst-mustard-light hover:text-catalyst-mustard transition-colors font-medium border-b border-catalyst-mustard-light/30 hover:border-catalyst-mustard pb-1" data-id="element-598">
              Not part of a cohort yet? Request Access
              <ArrowRight size={14} data-id="element-599" />
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="z-10 py-8 border-t border-white/5 text-center" data-id="element-600">
        <p className="text-xs text-gray-600" data-id="element-601">
          &copy; 2026 Black Opportunity Fund. All rights reserved.
        </p>
      </div>
    </div>;
}